(function () {
  'use strict';

  var endpoint = 'https://a.klaviyo.com/client/events/?company_id=YsNQrZ';
  var metricName = 'BF Contact Submitted';
  var guardStorageKey = 'bf_contact_accepted_times_v1';
  var guardWindow = 600000;
  var guardCooldown = 30000;
  var guardAcceptedTimes = [];
  var guardStorageUnavailable = false;
  var contexts = {
    business: 'Vertel ons over je bedrijf en wat je voor ogen hebt.',
    other: 'Vertel wat je wilt weten. Ook opmerkingen en suggesties zijn welkom.'
  };

  function recentAcceptedTimes() {
    var now = Date.now();
    if (!guardStorageUnavailable) {
      try {
        var stored = JSON.parse(window.sessionStorage.getItem(guardStorageKey) || '[]');
        guardAcceptedTimes = Array.isArray(stored) ? stored : [];
      } catch (error) {
        guardStorageUnavailable = true;
      }
    }
    guardAcceptedTimes = guardAcceptedTimes.filter(function (time) {
      return typeof time === 'number' && Number.isFinite(time) && time > now - guardWindow && time <= now;
    }).sort(function (a, b) { return a - b; }).slice(-3);
    return guardAcceptedTimes;
  }

  function guardUntil() {
    var times = recentAcceptedTimes();
    if (!times.length) return 0;
    var cooldown = times[times.length - 1] + guardCooldown;
    return times.length >= 3 ? Math.max(cooldown, times[0] + guardWindow) : cooldown;
  }

  function rememberAccepted() {
    var times = recentAcceptedTimes();
    times.push(Date.now());
    guardAcceptedTimes = times.slice(-3);
    if (!guardStorageUnavailable) {
      try {
        window.sessionStorage.setItem(guardStorageKey, JSON.stringify(guardAcceptedTimes));
      } catch (error) {
        guardStorageUnavailable = true;
      }
    }
  }

  function initialise(page) {
    if (page.dataset.bfContactReady) return;
    page.dataset.bfContactReady = 'true';
    var form = page.querySelector('[data-bf-contact-form]');
    var submit = page.querySelector('[data-bf-contact-submit]');
    var status = page.querySelector('[data-bf-contact-status]');
    var context = page.querySelector('[data-bf-contact-context]');
    var companyField = page.querySelector('[data-bf-contact-company]');
    var companyInput = form.elements.company;
    var busy = false;
    var acceptedFingerprint = null;
    var attempt = null;
    var retryUntil = 0;
    var retryTimer = null;

    function showStatus(state, message, focus) {
      status.hidden = false;
      status.dataset.state = state;
      status.setAttribute('role', state === 'error' ? 'alert' : 'status');
      status.textContent = message;
      if (focus) status.focus({ preventScroll: true });
    }

    function syncCategory() {
      var business = form.elements.category.value === 'business';
      companyField.hidden = !business;
      companyInput.disabled = !business;
      context.textContent = contexts[business ? 'business' : 'other'];
    }

    function values() {
      var data = new FormData(form);
      return {
        category: data.get('category') === 'other' ? 'other' : 'business',
        name: String(data.get('name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        company: data.get('category') === 'business' ? String(data.get('company') || '').trim() : '',
        subject: String(data.get('subject') || '').trim(),
        message: String(data.get('message') || '').trim()
      };
    }

    function uuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      var bytes = window.crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    }

    function buttonState() {
      submit.disabled = busy || Date.now() < retryUntil;
      submit.textContent = busy ? 'Bezig met versturen…' : Date.now() < retryUntil ? 'Even wachten…' : 'Verstuur bericht';
    }

    function waitUntil(time) {
      retryUntil = Math.max(retryUntil, time);
      window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(buttonState, Math.max(0, retryUntil - Date.now()) + 50);
      buttonState();
    }

    form.addEventListener('change', function (event) {
      if (event.target.name === 'category') syncCategory();
    });
    form.addEventListener('input', function (event) {
      if (event.target.name === 'website') return;
      event.target.setCustomValidity('');
      if (!busy && status.dataset.state === 'success') {
        status.hidden = true;
        status.textContent = '';
      }
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (busy) return;
      ['name', 'email', 'subject', 'message'].forEach(function (name) {
        var field = form.elements[name];
        field.setCustomValidity(field.value.trim() ? '' : 'Vul dit veld in.');
      });
      if (!form.reportValidity()) return;
      if (form.elements.website.value) {
        showStatus('error', 'Je bericht kon niet worden verstuurd. Vernieuw de pagina en probeer het opnieuw.', true);
        return;
      }
      var submitted = values();
      var fingerprint = JSON.stringify(submitted);
      if (fingerprint === acceptedFingerprint) {
        showStatus('success', 'Bedankt. Je bericht is ontvangen.', true);
        return;
      }
      var nextAllowed = Math.max(retryUntil, guardUntil());
      if (Date.now() < nextAllowed) {
        waitUntil(nextAllowed);
        var seconds = Math.ceil((nextAllowed - Date.now()) / 1000);
        var remaining = seconds > 60 ? Math.ceil(seconds / 60) + ' minuten' : seconds + ' seconden';
        showStatus('error', 'Wacht even voordat je nog een bericht verstuurt. Je kunt het opnieuw proberen over ' + remaining + '. Je bericht blijft hier staan.', true);
        return;
      }
      if (!navigator.onLine) {
        showStatus('error', 'Je lijkt offline te zijn. Herstel je verbinding en probeer het opnieuw. Je bericht blijft hier staan.', true);
        return;
      }
      if (!attempt || attempt.fingerprint !== fingerprint) attempt = { fingerprint: fingerprint, id: uuid() };
      var properties = Object.assign({}, submitted, {
        source: 'contact-page',
        language: 'nl',
        page_url: window.location.origin + window.location.pathname,
        submission_id: attempt.id,
        qa: false
      });
      var profileProperties = { bf_contact_language: 'nl' };
      profileProperties['bf_contact_' + submitted.category + '_name'] = submitted.name;
      if (submitted.category === 'business' && submitted.company) profileProperties.bf_contact_business_company = submitted.company;
      var payload = { data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: metricName } } },
        profile: { data: { type: 'profile', attributes: { email: submitted.email, properties: profileProperties } } },
        properties: properties,
        unique_id: attempt.id
      } } };
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 20000);
      busy = true;
      var pendingControls = Array.from(form.querySelectorAll('input, textarea, select')).map(function (control) {
        var previous = { control: control, disabled: control.disabled };
        control.disabled = true;
        return previous;
      });
      form.setAttribute('aria-busy', 'true');
      buttonState();
      showStatus('progress', 'Je bericht wordt verstuurd…', false);
      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'strict-origin-when-cross-origin',
          headers: { 'content-type': 'application/vnd.api+json', 'accept': 'application/vnd.api+json', 'revision': '2026-10-15' },
          body: JSON.stringify(payload),
          signal: controller.signal
        });
        if (response.status === 202) {
          acceptedFingerprint = fingerprint;
          rememberAccepted();
          waitUntil(guardUntil());
          showStatus('success', 'Bedankt. Je bericht is ontvangen.', true);
        } else if (response.status === 429) {
          var retry = Number(response.headers.get('retry-after'));
          waitUntil(Date.now() + Math.min(300000, Math.max(10000, Number.isFinite(retry) ? retry * 1000 : 30000)));
          showStatus('error', 'We konden je bericht nog niet versturen. Wacht even en probeer het opnieuw. Je bericht blijft hier staan.', true);
        } else {
          showStatus('error', 'We konden de ontvangst niet bevestigen. Probeer het opnieuw. Je bericht blijft hier staan.', true);
        }
      } catch (error) {
        showStatus('error', 'We konden de ontvangst niet bevestigen. Controleer je verbinding en probeer het opnieuw. Je bericht blijft hier staan.', true);
      } finally {
        window.clearTimeout(timeout);
        pendingControls.forEach(function (previous) { previous.control.disabled = previous.disabled; });
        busy = false;
        form.removeAttribute('aria-busy');
        buttonState();
      }
    });
    syncCategory();
    waitUntil(guardUntil());
  }

  function mount(root) {
    root.querySelectorAll('[data-bf-contact-page]').forEach(initialise);
  }
  mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
}());

